import React from 'react';
import { Globe } from 'lucide-react';
import { buildSubdomainUrl, buildDisplayDomain } from '../../../utils/domain';

const MobileHeader = ({ portfolio }) => {
  const customDomain = portfolio?.data?.customDomain?.trim() || '';
  const displayDomain = buildDisplayDomain(customDomain);
  const href = buildSubdomainUrl(customDomain);

  return (
    <div className="px-4 py-3">
      <h1 className="text-lg font-semibold text-notion-text tracking-tight">Capture Tools</h1>
      <a href={href} target="_blank" rel="noopener noreferrer" className="text-[10px] text-notion-text-light hover:underline flex items-center gap-1">
        <Globe className="w-3 h-3 text-stone-400" /> <span>{displayDomain}</span>
      </a>
    </div>
  );
};

export default MobileHeader;
